export const colors = [
    {name: 'purple', color: '#332e54'},
    {name: 'orange', color: '#f7882f'},
    {name: 'black', color: '#000000'},
    {name: 'gray', color: '#f4f4f4'},
    {name: 'red', color: '#ef3737'},
    {name: 'red-light', color: '#fa5d49'},
    {name: 'red-dark', color: '#aa0511'},
]
